import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { SwalService } from 'src/app/shared/services/swal.service';
import { TranslateService } from '@ngx-translate/core';
import { ProfileToolManagementService } from 'src/app/shared/services/profile-tool-management.service';
import { AdEnvironmentsCredentialsList } from 'src/app/features/credentials-management/pass-management/models/AdEnvironmentsCredentials';
import { Tool } from 'src/app/features/credentials-management/pass-management/models/ListData';



export interface DialogData {
  tool: Tool,
  environment: AdEnvironmentsCredentialsList,
  methodName: string
}
@Component({
  selector: 'app-confirm-access',
  standalone: false,
  templateUrl: './confirm-access.component.html'
})
export class ConfirmAccessComponent implements OnInit {
  dataLoading = false
  loading = false
  formGroup: FormGroup = new FormGroup({});
  hidePassword = true;
  errorMsg = ''

  constructor(
    private readonly swalService: SwalService,
    private dialogRef: MatDialogRef<ConfirmAccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private readonly translate: TranslateService,
    private service: ProfileToolManagementService
  ) {

  }

  ngOnInit(): void {
    this.buildForm()
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      password: ['', CustomValidator.noWhiteSpace],
    });
  }


  confirmAccess() {
    if (this.formGroup.valid) {
      this.loading = true;
      const controls = this.formGroup.controls;
      let data: any = {
        password: controls['password'].value,
      };
      if (this.data.methodName != 'validateADEnvironmentCredentials') data.toolId = this.data.tool.toolId
      if (this.data.environment && this.data.environment.adEnvironmentId) {
        data.adEnvironmentId = this.data.environment.adEnvironmentId
      }
      const service: any = this.service
      service[this.data.methodName](data).subscribe(
        (res: any) => {
          this.loading = false;
          if (this.data.tool) {
            res.toolCode = this.data.tool.toolCode
            res.toolSvg = this.data.tool.toolSvg
            res.toolName = this.data.tool.toolName
          }
          if (this.data.environment && this.data.environment.adEnvironmentId) {
            res.adEnvironmentId = this.data.environment.adEnvironmentId
            res.environmentName = this.data.environment.environmentName
          }
          this.dialogRef.close(res);
        },
        (error: any) => {
          this.loading = false;
          this.handleErrors(error.detail);
        }
      );
    }
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.formGroup.get('password')?.setErrors({ notMatch: true });
      this.errorMsg = error.Error
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup?.controls[controlName].hasError(errorName);
  }
}
